import { Injectable } from '@angular/core';
import { EntityType } from '@app/shared/enums/entity-type.enum';
import { ApiService } from './api.service';

@Injectable()
export class PasarelasService extends ApiService {
  entityType = EntityType.PASARELA;
  url = 'api/pasarelas/';
}
